import React from 'react';

import { Box, Typography } from '@mui/material';

import Stats from './Stats';
import { useIntelState } from '../../context/IntelState';

const Resources: React.FC = () => {
  const { intelState } = useIntelState();
  return (
    <Box>
      <Typography variant='h4' component='div'>
        Resources
      </Typography>
      {intelState?.ownData && (
        <Box>
          <Typography variant='body1' component='div' sx={{ my: 1 }}>
            Our KD
          </Typography>
          <Stats rows={intelState.ownData.provinces} />
        </Box>
      )}
      {intelState?.enemyData && (
        <Box>
          <Typography variant='body1' component='div' sx={{ my: 1 }}>
            Enemy KD
          </Typography>
          <Stats rows={intelState.enemyData.provinces} />
        </Box>
      )}
    </Box>
  );
};

export default Resources;
